import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const h = a((e, o) => /* @__PURE__ */ l.jsx(
  r,
  {
    ref: o,
    ...e,
    image: (i) => /* @__PURE__ */ l.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...i,
        children: /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zM9.821 20h-1.91l2.8-8.402h2.55l2.728 8.34 2.78-8.34h2.549L24.066 20h-1.94l-.62-2.016h-3L17.877 20H14.07l-.62-2.016h-3zm2.139-6.873-1.049 3.369h2.08zm8.057 0-1.049 3.369h2.08z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
h.displayName = "AzelaicAcidIcon";
export {
  h as AzelaicAcidIcon,
  h as default
};
//# sourceMappingURL=index.js.map
